import { takeLatest, put } from "redux-saga/effects";
import { OK } from "http-status-codes";
import { authentication } from "state/api/authentication";
import { withToken, genFetch } from "coral-utility";
import * as navigationActions from "./actions";
import navigationTypes from "./types";

// TODO Remove and replace with coral utility
interface ICoreResponse {
  data: any;
  message: string;
}

function* getNavigationItems() {
  try {
    const navigationResponse: Response = yield genFetch(authentication.getNavigation())(
      withToken()
    )();
    const { status } = navigationResponse;
    switch (status) {
      case OK: {
        const body: ICoreResponse = yield navigationResponse.json();
        yield put(navigationActions.setNavigationItemsAction(body.data));
        break;
      }
      default:
        yield put(navigationActions.getNavigationFailureAction());
        break;
    }
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
  }
}

export default function* navigationSaga() {
  yield takeLatest(navigationTypes.GET_NAVIGATION_ITEMS, getNavigationItems);
}
